import { useContext } from "react";
import { RequestContext } from "src/contexts/request-context";

export const useRequest = () => useContext(RequestContext);
